import React, { forwardRef, useCallback, useContext, useEffect, useRef } from 'react'
import styles from "../css/NoteMenu.module.css"
import { TbEdit } from "react-icons/tb";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { HiOutlineExternalLink } from "react-icons/hi";
import { debounce } from 'lodash';
import { PageContext } from './Notes';
import { useDispatch } from 'react-redux';

const SPACING = 15
const GAP = 5

const NoteMenu = forwardRef(({ id, closeMenu }, ref) => {
  const [pageModals,setPageModals] = useContext(PageContext)
  const menu = useRef(null)
  const dispatch = useDispatch()

  const setMenuPosition  = useCallback(() => {
    if (!menu.current && !ref?.current){
        return
    }
    else{
        menu.current.style.maxHeight = ""
        let btnCoords = ref.current.getBoundingClientRect()
        let height = menu.current.offsetHeight

        if (btnCoords.bottom - height - SPACING < 0){
            let aboveSpace = btnCoords.top
            let belowSpace = window.innerHeight - btnCoords.bottom
            if (belowSpace > aboveSpace){
                menu.current.style.top = `${btnCoords.bottom + GAP}px`
                menu.current.style.bottom = ""
                menu.current.style.maxHeight = `${window.innerHeight - btnCoords.bottom - GAP - SPACING}px`
            }
            else{
                menu.current.style.bottom =`${window.innerHeight - btnCoords.top + GAP}px`
                menu.current.style.top = ""
                menu.current.style.maxHeight = `${btnCoords.top - GAP - SPACING}px`
            }
        }
        else{
            menu.current.style.top = ""
            menu.current.style.bottom = `${window.innerHeight - btnCoords.top - GAP}px`
        }
        menu.current.style.right = `${window.innerWidth - btnCoords.right}px`
        
    }
  },[ref])

  useEffect(()=>{
      const handleResize = debounce(setMenuPosition, 200)
      const handleClick = (e) => {
        if (!menu.current?.contains(e.target) && !ref.current?.contains(e.target)){
          closeMenu()
        }
      }
      window.addEventListener("mousedown",handleClick)
      window.addEventListener("resize",handleResize)
      return () => {
        window.removeEventListener("mousedown",handleClick)
        window.removeEventListener("resize",handleResize)
      }
  },[setMenuPosition,ref,closeMenu])

  const setMenu = useCallback((el) => {
    if (el) {
      menu.current = el
      requestAnimationFrame(() => setMenuPosition())
    }
  }, [setMenuPosition]);

  const handleMenu = (attr) => {
    dispatch({type: "MODAL_RESET"})
    setPageModals({...pageModals,[attr]:id})
    closeMenu()
  }

  return (
    <div data-testid = "note-menu" className={styles.menu} ref = {setMenu}>
      <button type = "button" data-testid = "view-btn" className={styles.item} onClick = {()=>handleMenu("view")}>
        <div className={styles.icon}><HiOutlineExternalLink/></div>
          View Note
      </button>
      <button type = "button" data-testid = "edit-btn" className={styles.item} onClick = {()=>handleMenu("edit")}>
        <div className={styles.icon}><TbEdit/></div>
          Edit Note
      </button>
      <div className={styles.divider}></div>
      <button type = "button" data-testid = "delete-btn" className={`${styles.item} ${styles.danger}`} onClick = {()=>handleMenu("delete")}>
        <div className={styles.icon}><MdOutlineDeleteOutline/></div>
          Delete
      </button>
    </div>
  )
})

export default NoteMenu